import { Helmet } from 'react-helmet-async';

export function AnalyticsPage() {
  return (
    <>
      <Helmet>
        <title>Analytics - Urban Finch Admin</title>
      </Helmet>
      <div data-testid="analytics-page">
        <div className="space-y-2" data-testid="analytics-header">
          <h1 className="text-2xl font-semibold tracking-tight lg:text-3xl">
            Analytics
          </h1>
          <p className="text-muted-foreground">
            View detailed analytics and insights.
          </p>
        </div>

        <div data-testid="analytics-content">
          <div className="rounded-lg border border-dashed border-gray-200 p-8 text-center">
            <h3 className="text-lg font-medium">Coming Soon</h3>
            <p className="text-muted-foreground">
              Analytics dashboard will be implemented in Epic 2.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
